<template>
  <div class="protection-page">
    <main class="protection-card" aria-labelledby="terms-title">
      <p class="protection-eyebrow">Legal</p>
      <h1 id="terms-title" class="protection-title">Terms and Conditions</h1>

      <p class="protection-lede">
        Welcome to PACM MyChart! These terms and conditions outline the rules and
        regulations for the use of PACM MyChart's Website, located at
        https://parkavenueconciergemedicine.com/.
      </p>
      <p>
        By accessing this website we assume you accept these terms and conditions. Do not
        continue to use PACM MyChart if you do not agree to take all of the terms and
        conditions stated on this page.
      </p>

      <section aria-labelledby="terms-cookies">
        <h2 id="terms-cookies" class="protection-heading">Cookies</h2>
        <p>
          The website uses cookies to help personalize your online experience. By
          accessing PACM MyChart, you agreed to use the required cookies.
        </p>
      </section>

      <section aria-labelledby="terms-license">
        <h2 id="terms-license" class="protection-heading">License</h2>
        <p>
          Unless otherwise stated, PACM MyChart and/or its licensors own the intellectual
          property rights for all material on PACM MyChart. All intellectual property
          rights are reserved. You may access this from PACM MyChart for your own personal
          use subjected to restrictions set in these terms and conditions.
        </p>
        <p>You must not:</p>
        <ul class="protection-list">
          <li>Republish material from PACM MyChart</li>
          <li>Sell, rent or sub-license material from PACM MyChart</li>
          <li>Reproduce, duplicate or copy material from PACM MyChart</li>
          <li>Redistribute content from PACM MyChart</li>
        </ul>
        <p>
          Parts of this website offer an opportunity for users to post and exchange
          opinions and information in certain areas of the website. PACM MyChart does not
          filter, edit, publish or review Comments prior to their presence on the website.
          Comments do not reflect the views and opinions of PACM MyChart, its agents
          and/or affiliates. Comments reflect the views and opinions of the person who
          post their views and opinions. To the extent permitted by applicable laws, PACM
          MyChart shall not be liable for the Comments or for any liability, damages or
          expenses caused and/or suffered as a result of any use of and/or posting of
          and/or appearance of the Comments on this website.
        </p>
      </section>

      <section aria-labelledby="terms-hyperlinking">
        <h2 id="terms-hyperlinking" class="protection-heading">Hyperlinking to our Content</h2>
        <p>The following organizations may link to our Website without prior written approval:</p>
        <ul class="protection-list">
          <li>Government agencies;</li>
          <li>Search engines;</li>
          <li>News organizations;</li>
          <li>
            Online directory distributors may link to our Website in the same manner as
            they hyperlink to the Websites of other listed businesses; and
          </li>
          <li>
            System wide Accredited Businesses except soliciting non-profit organizations,
            charity shopping malls, and charity fundraising groups which may not hyperlink
            to our Web site.
          </li>
        </ul>
        <p>
          These organizations may link to our home page, to publications or to other
          Website information so long as the link: (a) is not in any way deceptive; (b)
          does not falsely imply sponsorship, endorsement or approval of the linking party
          and its products and/or services; and (c) fits within the context of the linking
          party's site.
        </p>
      </section>

      <section aria-labelledby="terms-iframes">
        <h2 id="terms-iframes" class="protection-heading">iFrames</h2>
        <p>
          Without prior approval and written permission, you may not create frames around
          our Webpages that alter in any way the visual presentation or appearance of our
          Website.
        </p>
      </section>

      <section aria-labelledby="terms-content-liability">
        <h2 id="terms-content-liability" class="protection-heading">Content Liability</h2>
        <p>
          We shall not be held responsible for any content that appears on your Website.
          You agree to protect and defend us against all claims that is rising on your
          Website. No link(s) should appear on any Website that may be interpreted as
          libelous, obscene or criminal, or which infringes, otherwise violates, or
          advocates the infringement or other violation of, any third party rights.
        </p>
      </section>

      <section aria-labelledby="terms-reservation">
        <h2 id="terms-reservation" class="protection-heading">Reservation of Rights</h2>
        <p>
          We reserve the right to request that you remove all links or any particular link
          to our Website. You approve to immediately remove all links to our website upon
          request. We also reserve the right to amend these terms and conditions and its
          linking policy at any time. By continuously linking to our Website, you agree to
          be bound to and follow these linking terms and conditions.
        </p>
      </section>

      <section aria-labelledby="terms-removal">
        <h2 id="terms-removal" class="protection-heading">Removal of links from our website</h2>
        <p>
          If you find any link on our Website that is offensive for any reason, you are
          free to contact and inform us at any moment. We will consider requests to remove
          links but we are not obligated to or so or to respond to you directly.
        </p>
        <p>
          We do not ensure that the information on this website is correct, we do not
          warrant its completeness or accuracy; nor do we promise to ensure that the
          website remains available or that the material on the website is kept up to
          date.
        </p>
      </section>

      <section aria-labelledby="terms-disclaimer">
        <h2 id="terms-disclaimer" class="protection-heading">Disclaimer</h2>
        <p>
          To the maximum extent permitted by applicable law, we exclude all
          representations, warranties and conditions relating to our website and the use
          of this website. Nothing in this disclaimer will:
        </p>
        <ul class="protection-list">
          <li>limit or exclude our or your liability for death or personal injury;</li>
          <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
          <li>limit any of our or your liability in any way that is not permitted under applicable law; or</li>
          <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions",
};
</script>

<style scoped lang="scss">
$color-ink: #17233d;
$color-body: #33415c;
$color-accent: #0060ff;
$color-border: #e2e8f0;

.protection-page {
  min-height: 100vh;
  width: 100%;
  padding: 3rem 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(160deg, #eef3fb 0%, #f7f9fc 55%, #ffffff 100%);
}

.protection-card {
  width: 100%;
  max-width: 46rem;
  background: #ffffff;
  border: 1px solid $color-border;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(15, 30, 60, 0.08);
  padding: 2.75rem clamp(1.5rem, 5vw, 3.5rem);
  color: $color-body;
  line-height: 1.65;
  font-size: 1.05rem;
}

.protection-eyebrow {
  margin: 0 0 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  font-weight: 700;
  color: $color-accent;
}

.protection-title {
  margin: 0 0 1.25rem;
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  font-weight: 700;
  color: $color-ink;
  letter-spacing: -0.01em;
}

.protection-lede {
  font-size: 1.1rem;
  color: $color-ink;
}

.protection-heading {
  margin: 2rem 0 1rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: $color-ink;
  padding-top: 1.5rem;
  border-top: 1px solid $color-border;
}

p {
  margin: 0 0 1.1rem;
}

.protection-list {
  margin: 0 0 1.1rem;
  padding-left: 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.protection-list li {
  padding-left: 0.25rem;
}

@media (max-width: 40rem) {
  .protection-page {
    padding: 1.5rem 0.75rem;
  }

  .protection-card {
    padding: 2rem 1.25rem;
    font-size: 1rem;
  }
}
</style>
